// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_0FkI-","tag":"tag_Frl1V","absolute":"absolute_3Xs-2","default-tag":"default-tag_WoiNY","xmas-tag":"xmas-tag_AKfSO"};